/*
 * Copyright (c) 2018 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2018 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:   AnnotationActions.js
 *
 * Description: JavaScript functions for all functionality accessed through the shape handles.
 *
 */

var g_oAnnotationActions = {};

(function () {
	"use strict";

	/**
	 * Prototype for our AnnotationActions object.
	 * @class
	 */
	function AnnotationAction() {

		// Move icons.
		this.g_oCursorMoveIcon = new Image();
		this.g_oCursorMoveIcon.src = "img/cursor-move-icon.png";
		this.g_oCursorMoveIconBlk = new Image();
		this.g_oCursorMoveIconBlk.src = "img/cursor-move-icon_blk.png";

		// Delete icons.
		this.g_oDeleteIcon = new Image();
		this.g_oDeleteIcon.src = "img/Delete_wht_16.png";
		this.g_oDeleteIcon90 = new Image();
		this.g_oDeleteIcon90.src = "img/Delete_wht_16_90.png";
		this.g_oDeleteIcon180 = new Image();
		this.g_oDeleteIcon180.src = "img/Delete_wht_16_180.png";
		this.g_oDeleteIcon270 = new Image();
		this.g_oDeleteIcon270.src = "img/Delete_wht_16_270.png";
		this.g_oDeleteIconBlk = new Image();
		this.g_oDeleteIconBlk.src = "img/Delete_blk_16.png";
		this.g_oDeleteIconBlk90 = new Image();
		this.g_oDeleteIconBlk90.src = "img/Delete_blk_16_90.png";
		this.g_oDeleteIconBlk180 = new Image();
		this.g_oDeleteIconBlk180.src = "img/Delete_blk_16_180.png";
		this.g_oDeleteIconBlk270 = new Image();
		this.g_oDeleteIconBlk270.src = "img/Delete_blk_16_270.png";

		// New annotation icons.
		this.g_oNewAnnoIcon = new Image();
		this.g_oNewAnnoIcon.src = "img/Annotation_wht_16.png";
		this.g_oNewAnnoIconBlk = new Image();
		this.g_oNewAnnoIconBlk.src = "img/Annotation_blk_16.png";

		// Add text icons.
		this.g_oAddTextIcon = new Image();
		this.g_oAddTextIcon.src = "img/TextCursor_24 white.png";
		this.g_oAddTextIcon90 = new Image();
		this.g_oAddTextIcon90.src = "img/TextCursor_24 90 white.png";
		this.g_oAddTextIcon180 = new Image();
		this.g_oAddTextIcon180.src = "img/TextCursor_24 180 white.png";
		this.g_oAddTextIcon270 = new Image();
		this.g_oAddTextIcon270.src = "img/TextCursor_24 270 white.png";
		this.g_oAddTextIconBlk = new Image();
		this.g_oAddTextIconBlk.src = "img/TextCursor_24 black.png";
		this.g_oAddTextIconBlk90 = new Image();
		this.g_oAddTextIconBlk90.src = "img/TextCursor_24 90 black.png";
		this.g_oAddTextIconBlk180 = new Image();
		this.g_oAddTextIconBlk180.src = "img/TextCursor_24 180 black.png";
		this.g_oAddTextIconBlk270 = new Image();
		this.g_oAddTextIconBlk270.src = "img/TextCursor_24 270 black.png";

		// Remove text icons.
		this.g_oRemoveTextIcon = new Image();
		this.g_oRemoveTextIcon.src = "img/TextCursorRemove_24 white.png";
		this.g_oRemoveTextIcon90 = new Image();
		this.g_oRemoveTextIcon90.src = "img/TextCursorRemove_24 90 white.png";
		this.g_oRemoveTextIcon180 = new Image();
		this.g_oRemoveTextIcon180.src = "img/TextCursorRemove_24 180 white.png";
		this.g_oRemoveTextIcon270 = new Image();
		this.g_oRemoveTextIcon270.src = "img/TextCursorRemove_24 270 white.png";
		this.g_oRemoveTextIconBlk = new Image();
		this.g_oRemoveTextIconBlk.src = "img/TextCursorRemove_24 black.png";
		this.g_oRemoveTextIconBlk90 = new Image();
		this.g_oRemoveTextIconBlk90.src = "img/TextCursorRemove_24 90 black.png";
		this.g_oRemoveTextIconBlk180 = new Image();
		this.g_oRemoveTextIconBlk180.src = "img/TextCursorRemove_24 180 black.png";
		this.g_oRemoveTextIconBlk270 = new Image();
		this.g_oRemoveTextIconBlk270.src = "img/TextCursorRemove_24 270 black.png";

		// Add paragraph icons.
		this.g_oAddParagraphIcon = new Image();
		this.g_oAddParagraphIcon.src = "img/ParagraphCursor_24 white.png";
		this.g_oAddParagraphIcon90 = new Image();
		this.g_oAddParagraphIcon90.src = "img/ParagraphCursor_24 90 white.png";
		this.g_oAddParagraphIcon180 = new Image();
		this.g_oAddParagraphIcon180.src = "img/ParagraphCursor_24 180 white.png";
		this.g_oAddParagraphIcon270 = new Image();
		this.g_oAddParagraphIcon270.src = "img/ParagraphCursor_24 270 white.png";
		this.g_oAddParagraphIconBlk = new Image();
		this.g_oAddParagraphIconBlk.src = "img/ParagraphCursor_24 black.png";
		this.g_oAddParagraphIconBlk90 = new Image();
		this.g_oAddParagraphIconBlk90.src = "img/ParagraphCursor_24 90 black.png";
		this.g_oAddParagraphIconBlk180 = new Image();
		this.g_oAddParagraphIconBlk180.src = "img/ParagraphCursor_24 180 black.png";
		this.g_oAddParagraphIconBlk270 = new Image();
		this.g_oAddParagraphIconBlk270.src = "img/ParagraphCursor_24 270 black.png";

		// Add area icons.
		this.g_oAddAreaIcon = new Image();
		this.g_oAddAreaIcon.src = "img/AreaCursor_24 White.png";
		this.g_oAddAreaIcon90 = new Image();
		this.g_oAddAreaIcon90.src = "img/AreaCursor_24 90 White.png";
		this.g_oAddAreaIcon180 = new Image();
		this.g_oAddAreaIcon180.src = "img/AreaCursor_24 180 White.png";
		this.g_oAddAreaIcon270 = new Image();
		this.g_oAddAreaIcon270.src = "img/AreaCursor_24 270 White.png";
		this.g_oAddAreaIconBlk = new Image();
		this.g_oAddAreaIconBlk.src = "img/AreaCursor_24 black.png";
		this.g_oAddAreaIconBlk90 = new Image();
		this.g_oAddAreaIconBlk90.src = "img/AreaCursor_24 90 black.png";
		this.g_oAddAreaIconBlk180 = new Image();
		this.g_oAddAreaIconBlk180.src = "img/AreaCursor_24 180 black.png";
		this.g_oAddAreaIconBlk270 = new Image();
		this.g_oAddAreaIconBlk270.src = "img/AreaCursor_24 270 black.png";

		// Set the annotation drag rectangle size.
		this.g_iAnnotationDragRectSize = 20 * g_oViewer.c_iDPI;

		// Get the artwork canvas.
		this.g_oArtworkCanvas = g_oViewer.g_oArtworkViewer;

		// Get the annotation canvas.
		this.g_oAnnotationCanvas = g_oViewer.getCanvas(g_oCompare.getAnnotationCanvasId());

		// Set the canvas details.
		this.g_oAnnotation = null;
		this.g_iCompareRotation = 0;
		this.g_iImageObjW = 0;
		this.g_iImageObjH = 0;
		this.g_iCenterShift_x = 0;
		this.g_iCenterShift_y = 0;
		this.g_iCompareOffset_x = 0;
		this.g_iCompareOffset_y = 0;
		this.g_iDragRectOffset = 10;
		this.g_oAnnotationResizeHandleSize = [30 * g_oViewer.c_iDPI, 5 * g_oViewer.c_iDPI];
	}

	/**
	 * Initializes the annotation
	 * @param {any} oAnnotation - The annotation to initialize.
	 */
	AnnotationAction.prototype.initializeAnnotationAction = function (oAnnotation) {
		// Set the canvases
		g_oAnnotationActions.g_oAnnotationCanvas = g_oViewer.getCanvas(g_oCompare.getAnnotationCanvasId());
		g_oAnnotationActions.g_oArtworkCanvas = g_oViewer.g_oArtworkViewer;
		// Get the compare rotation of the canvas.
		g_oAnnotationActions.g_iCompareRotation = g_oCompare.getCompareRotation(g_oAnnotationActions.g_oArtworkCanvas);
		// Get the height, width, shift and compare offset of the artwork canvas.
		g_oAnnotationActions.g_iImageObjW = (g_oAnnotationActions.g_iCompareRotation === 90 || g_oAnnotationActions.g_iCompareRotation === 270) ? g_oAnnotationActions.g_oArtworkCanvas.g_iScaledImageHeight : g_oAnnotationActions.g_oArtworkCanvas.g_iScaledImageWidth;
		g_oAnnotationActions.g_iImageObjH = (g_oAnnotationActions.g_iCompareRotation === 90 || g_oAnnotationActions.g_iCompareRotation === 270) ? g_oAnnotationActions.g_oArtworkCanvas.g_iScaledImageWidth : g_oAnnotationActions.g_oArtworkCanvas.g_iScaledImageHeight;
		g_oAnnotationActions.g_iCenterShift_x = g_oAnnotationActions.g_oArtworkCanvas.g_iCenterShift_x;
		g_oAnnotationActions.g_iCenterShift_y = g_oAnnotationActions.g_oArtworkCanvas.g_iCenterShift_y;
		var co = g_oCompare.calculateCompareOffsetInPx(g_oAnnotationActions.g_oArtworkCanvas);
		g_oAnnotationActions.g_iCompareOffset_x = co.x;
		g_oAnnotationActions.g_iCompareOffset_y = co.y;

		// The annotation object
		g_oAnnotationActions.g_oAnnotation = oAnnotation;

	};

	/**
	 * Creates all annotation handles applicable to the annotation.
	 * @param {any} oAnnotation - The annotation to create the handles for.
	 */
	AnnotationAction.prototype.createAnnotationHandle = function (oAnnotation) {

		// The annotation's drag handle will be created to the top and right of the annotation.
		// This will be irrespective of canvas rotation.
		// The drag rectangle will display north-east of the annotation itself, offset by 20px each way.
		// This way we don't get affected by zoom level.

		this.initializeAnnotationAction(oAnnotation);

		if (!oAnnotation.g_bSaved || !this.g_oArtworkCanvas.g_bMainCanvas || (g_oAnnotations.g_oArtworkViewer.g_oAnnotationCanvas !== this.g_oAnnotationCanvas) || oAnnotation.g_bClosed || oAnnotation.g_iAuthor !== g_oUserDetails.UserId) { // If the current user doesn't have the permissions to edit the annotation or the annotation is closed.
			return; // Avoid drawing any handles.
		}

		// Don't draw anything for text, colour density, barcode, SVG or global annotations.
		if (g_oAnnotationActions.g_oAnnotation.g_iAnnotationType === 5 ||
			g_oAnnotationActions.g_oAnnotation.g_iAnnotationType === 7 ||
			g_oAnnotationActions.g_oAnnotation.g_iAnnotationType === 12 ||
			g_oAnnotationActions.g_oAnnotation.g_iAnnotationType === 13 ||
			g_oAnnotationActions.g_oAnnotation.g_iAnnotationType === 14 ||
			g_oAnnotationActions.g_oAnnotation.g_bSVGTextAnnotation === true) {
			return false;
		}

		if (oAnnotation.g_iAnnotationType === eAnnotationTypes.Postit) { // Do not draw resize handles for post-it notes
			// Calculate coordinates for the handle
			var oHandleCoords = this.calculateAnnotationHandleCoords(g_oAnnotationActions.g_oArtworkCanvas.g_iRotDegrees, 0);
			// Draw annotation Drag Handle
			this.drawAnnotationHandle(oHandleCoords, g_oAnnotationActions.g_oAnnotation.g_szColour, true, 0);
			// Draw annotation Delete handle if it's not the parent
			if (oAnnotation.g_iParentAnnotationId !== 0) {
				var oHandleCoords2 = this.calculateAnnotationHandleCoords(g_oAnnotationActions.g_oArtworkCanvas.g_iRotDegrees, 1);
				this.drawAnnotationHandle(oHandleCoords2, g_oAnnotationActions.g_oAnnotation.g_szColour, true, 1);
			}
		}
		else {
			for (var iHandleType in Object.keys(eAnnotationHandleTypes)) {
				if (parseInt(iHandleType) == eAnnotationHandleTypes.DeleteButton && oAnnotation.g_iParentAnnotationId == 0 ||
					parseInt(iHandleType) == eAnnotationHandleTypes.CreateNewAnnotation) { // Don't draw the delete handle for parent shapes. Don't draw if it's the createNewAnnotation handle.
					continue;
				}
				else {
					// Calculate coordinates for the handle
					var oHandleCoords = this.calculateAnnotationHandleCoords(g_oAnnotationActions.g_oArtworkCanvas.g_iRotDegrees, parseInt(iHandleType));
					// Draw annotation Handle
					this.drawAnnotationHandle(oHandleCoords, g_oAnnotationActions.g_oAnnotation.g_szColour, true, parseInt(iHandleType));
				}
			}
		}
	};

	/**
	 * Draws the handle for the current annotation.
	 * @param {array} oHandleCoords - Where to draw
	 * @param {string} szColour - The colour to draw the background
	 * @param {bool} bDrawImage - What image to use
	 * @param {enum} iHandleType - What type of handle
	 * @param {object} oAnnoContext - The current context of the annotation
	 */
	AnnotationAction.prototype.drawAnnotationHandle = function (oHandleCoords, szColour, bDrawImage, iHandleType, oAnnoContext) {
		var oSize = this.calculateAnnotationHandleSize(iHandleType);
		var oAnnotationContext = typeof oAnnoContext === "undefined" ? g_oAnnotationActions.g_oAnnotationCanvas.g_oContext : oAnnoContext;

		// Draw handle
		oAnnotationContext.save();
		oAnnotationContext.beginPath();
		oAnnotationContext.fillStyle = szColour;
		oAnnotationContext.strokeStyle = szColour;
		oAnnotationContext.rect(oHandleCoords[0], oHandleCoords[1], oSize[0], oSize[1]);
		oAnnotationContext.closePath();
		oAnnotationContext.fill();

		var bBrightColor = szColour === eAnnotationColours.yellow || szColour === eAnnotationColours.cyan;

		if (bDrawImage) {
			switch (iHandleType) {
				case eAnnotationHandleTypes.CreateNewAnnotation:
					oAnnotationContext.drawImage(bBrightColor ? g_oAnnotationActions.g_oNewAnnoIconBlk : g_oAnnotationActions.g_oNewAnnoIcon, oHandleCoords[0] + 2, oHandleCoords[1] + 2, oSize[0] - 4, oSize[1] - 4);
					break;
				case eAnnotationHandleTypes.DragRect:
					oAnnotationContext.drawImage(bBrightColor ? g_oAnnotationActions.g_oCursorMoveIconBlk : g_oAnnotationActions.g_oCursorMoveIcon, oHandleCoords[0] + 2, oHandleCoords[1] + 2, oSize[0] - 4, oSize[1] - 4);
					break;
				case eAnnotationHandleTypes.LeftResize:
				case eAnnotationHandleTypes.RightResize:
				case eAnnotationHandleTypes.TopResize:
				case eAnnotationHandleTypes.BottomResize:
					oAnnotationContext.beginPath();
					oAnnotationContext.rect(oHandleCoords[0] + 1, oHandleCoords[1] + 1, oSize[0] - 2, oSize[1] - 2);
					oAnnotationContext.closePath();
					oAnnotationContext.fillStyle = bBrightColor ? "rgba(0,0,0,0.4875)" : "rgba(255,255,255,0.75)";
					oAnnotationContext.fill();
					break;
				case eAnnotationHandleTypes.DeleteButton:
					switch (g_oAnnotationActions.g_oArtworkCanvas.g_iRotDegrees) {
						case 90:
							oAnnotationContext.drawImage(bBrightColor ? g_oAnnotationActions.g_oDeleteIconBlk270 : g_oAnnotationActions.g_oDeleteIcon270, oHandleCoords[0] + 1, oHandleCoords[1] + 1, oSize[0] - 2, oSize[1] - 2);
							break;
						case 180:
							oAnnotationContext.drawImage(bBrightColor ? g_oAnnotationActions.g_oDeleteIconBlk180 : g_oAnnotationActions.g_oDeleteIcon180, oHandleCoords[0] + 1, oHandleCoords[1] + 1, oSize[0] - 2, oSize[1] - 2);
							break;
						case 270:
							oAnnotationContext.drawImage(bBrightColor ? g_oAnnotationActions.g_oDeleteIconBlk90 : g_oAnnotationActions.g_oDeleteIcon90, oHandleCoords[0] + 1, oHandleCoords[1] + 1, oSize[0] - 2, oSize[1] - 2);
							break;
						default:
							oAnnotationContext.drawImage(bBrightColor ? g_oAnnotationActions.g_oDeleteIconBlk : g_oAnnotationActions.g_oDeleteIcon, oHandleCoords[0] + 1, oHandleCoords[1] + 1, oSize[0] - 2, oSize[1] - 2);
							break;
					}
					break;
				default:
					break;
			}
		}


	};

	/**
	 * Calculate handle size based on type.
	 * @param {enum} iHandleType - Type of handle.
	 */
	AnnotationAction.prototype.calculateAnnotationHandleSize = function (iHandleType) {
		switch (iHandleType) {
			case eAnnotationHandleTypes.CreateNewAnnotation:
			case eAnnotationHandleTypes.DragRect:
			case eAnnotationHandleTypes.DeleteButton:
				return [g_oAnnotationActions.g_iAnnotationDragRectSize, g_oAnnotationActions.g_iAnnotationDragRectSize];
			case eAnnotationHandleTypes.LeftResize:
			case eAnnotationHandleTypes.RightResize:
				return [g_oAnnotationActions.g_oAnnotationResizeHandleSize[1], g_oAnnotationActions.g_oAnnotationResizeHandleSize[0]];
			case eAnnotationHandleTypes.TopResize:
			case eAnnotationHandleTypes.BottomResize:
				return [g_oAnnotationActions.g_oAnnotationResizeHandleSize[0], g_oAnnotationActions.g_oAnnotationResizeHandleSize[1]];
			default:
				return [0, 0];
		}
	};

	/**
	 * Calculate the canvas annotation handle coordinates based on the handle type and the rotation.
	 * @param {int} iRotDegrees - Current rotation of the canvas.
	 * @param {enum} iHandleType - Type of handle.
	 */
	AnnotationAction.prototype.calculateAnnotationHandleCoords = function (iRotDegrees, iHandleType) {

		var iHandleX, iHandleY, iMinX, iMinY, iMaxX, iMaxY;
		var oAnnotationDrawArray = g_oAnnotationActions.g_oAnnotation.g_oDrawArray;
		var oSize = g_oAnnotationActions.calculateAnnotationHandleSize(iHandleType);

		// Work out bounds of shape
		iMinX = oAnnotationDrawArray.concat().sort(sortAnnotationCoords.returnXMin)[0][0];
		iMaxX = oAnnotationDrawArray.concat().sort(sortAnnotationCoords.returnXMax)[0][0];
		iMinY = oAnnotationDrawArray.concat().sort(sortAnnotationCoords.returnYMin)[0][1];
		iMaxY = oAnnotationDrawArray.concat().sort(sortAnnotationCoords.returnYMax)[0][1];

		switch (iHandleType) {
			case eAnnotationHandleTypes.CreateNewAnnotation:
			case eAnnotationHandleTypes.DragRect:
			case eAnnotationHandleTypes.DeleteButton:
				var iOffset = (iHandleType == eAnnotationHandleTypes.DeleteButton) ? g_oAnnotationActions.g_iDragRectOffset * 2 + oSize[0] : g_oAnnotationActions.g_iDragRectOffset;
				switch (iRotDegrees) {
					case 90:
						// min of x. min of y.
						iHandleX = iMinX * g_oAnnotationActions.g_iImageObjW;
						iHandleY = (iMinY * g_oAnnotationActions.g_iImageObjH) - oSize[1] - iOffset;
						break;
					case 180:
						// Min of x. Max of y.
						iHandleX = (iMinX * g_oAnnotationActions.g_iImageObjW) - oSize[0] - iOffset;
						iHandleY = (iMaxY * g_oAnnotationActions.g_iImageObjH) - oSize[1];
						break;
					case 270:
						// max of x. max of y.
						iHandleX = iMaxX * g_oAnnotationActions.g_iImageObjW - oSize[0];
						iHandleY = iMaxY * g_oAnnotationActions.g_iImageObjH + iOffset;
						break;
					default:
						// Max of X. Min of y.
						iHandleX = iMaxX * g_oAnnotationActions.g_iImageObjW + iOffset;
						iHandleY = iMinY * g_oAnnotationActions.g_iImageObjH;
						break;
				}
				break;
			case eAnnotationHandleTypes.LeftResize:
				iHandleX = iMinX * g_oAnnotationActions.g_iImageObjW;
				iHandleX -= oSize[0] / 2;
				iHandleY = iMinY * g_oAnnotationActions.g_iImageObjH;
				iHandleY += (iMaxY - iMinY) / 2 * g_oAnnotationActions.g_iImageObjH;
				iHandleY -= oSize[1] / 2;
				break;
			case eAnnotationHandleTypes.RightResize:
				iHandleX = iMaxX * g_oAnnotationActions.g_iImageObjW;
				iHandleX -= oSize[0] / 2;
				iHandleY = iMinY * g_oAnnotationActions.g_iImageObjH;
				iHandleY += (iMaxY - iMinY) / 2 * g_oAnnotationActions.g_iImageObjH;
				iHandleY -= oSize[1] / 2;
				break;
			case eAnnotationHandleTypes.TopResize:
				iHandleX = iMinX * g_oAnnotationActions.g_iImageObjW;
				iHandleX += (iMaxX - iMinX) / 2 * g_oAnnotationActions.g_iImageObjW;
				iHandleX -= oSize[0] / 2;
				iHandleY = iMinY * g_oAnnotationActions.g_iImageObjH;
				iHandleY -= oSize[1] / 2;
				break;
			case eAnnotationHandleTypes.BottomResize:
				iHandleX = iMinX * g_oAnnotationActions.g_iImageObjW;
				iHandleX += (iMaxX - iMinX) / 2 * g_oAnnotationActions.g_iImageObjW;
				iHandleX -= oSize[0] / 2;
				iHandleY = iMaxY * g_oAnnotationActions.g_iImageObjH;
				iHandleY -= oSize[1] / 2;
				break;
			default:
				break;
		}

		// Post it note is drawn with different offsets as it is an image.
		if (g_oAnnotationActions.g_oAnnotation.g_iAnnotationType === eAnnotationTypes.Postit) {
			var heightOffset = 13;
			var widthOffset = 3;
			var AnnotationDragRectSize = g_oAnnotationActions.g_iAnnotationDragRectSize;
			var iFactor = (iHandleType == eAnnotationHandleTypes.DeleteButton) ? g_oAnnotationActions.g_iDragRectOffset + AnnotationDragRectSize : 0;
			var x = oAnnotationDrawArray[0][0] * g_oAnnotationActions.g_iImageObjW - widthOffset;
			var y = oAnnotationDrawArray[0][1] * g_oAnnotationActions.g_iImageObjH - heightOffset;
			switch (iRotDegrees) {
				case 90:
					iHandleX = x - AnnotationDragRectSize;
					iHandleY = y - (AnnotationDragRectSize + iFactor);
					break;
				case 180:
					iHandleX = x - (AnnotationDragRectSize + iFactor);
					iHandleY = y + AnnotationDragRectSize;
					break;
				case 270:
					iHandleX = x + AnnotationDragRectSize;
					iHandleY = y + (AnnotationDragRectSize + iFactor);
					break;
				default:
					iHandleX = x + (AnnotationDragRectSize + iFactor);
					iHandleY = y - AnnotationDragRectSize;
					break;
			}
		}

		iHandleX += g_oAnnotationActions.g_iCenterShift_x;
		iHandleY += g_oAnnotationActions.g_iCenterShift_y;
		iHandleX += g_oAnnotationActions.g_iCompareOffset_x;
		iHandleY += g_oAnnotationActions.g_iCompareOffset_y;

		return [iHandleX, iHandleY];
	};

	// Checks if the user click coordinates are within any of the handles of the annotation.
	AnnotationAction.prototype.isclickWithinAnnotationAnyHandle = function (oClickCoords, oAnnotation) {

		// If the annotation is open and the user has permissions to edit it and it's not a TextMeasurement/TextHighlight/ColourDensity/Barcode/Global/SVG annotation.
		if (!g_oApproval.ReadOnly() && this.g_oArtworkCanvas.g_bMainCanvas && !oAnnotation.g_bClosed && (oAnnotation.g_iAuthor === g_oUserDetails.UserId)
			&& oAnnotation.g_iAnnotationType !== eAnnotationTypes.Global && oAnnotation.g_iAnnotationType !== eAnnotationTypes.TextMeasurement && oAnnotation.g_iAnnotationType !== eAnnotationTypes.ColourDensityMeasurement &&
			oAnnotation.g_iAnnotationType !== eAnnotationTypes.BarcodeMeasurement && oAnnotation.g_iAnnotationType !== eAnnotationTypes.ColourDensityMeasurementPostit &&
			oAnnotation.g_iAnnotationType !== eAnnotationTypes.TextHighlight && oAnnotation.g_iAnnotationType !== eAnnotationTypes.TextClassification && oAnnotation.g_bSVGTextAnnotation === false) {

			// Initialise the annotation action.
			this.initializeAnnotationAction(oAnnotation);
			for (var iHandleType in Object.keys(eAnnotationHandleTypes)) {

				// If it's the parent shape, ignore the delete button.
				if ((oAnnotation.g_iParentAnnotationId == 0 && iHandleType == eAnnotationHandleTypes.DeleteButton) || (oAnnotation.g_iAnnotationType === eAnnotationTypes.Postit && (iHandleType != eAnnotationHandleTypes.DragRect && iHandleType != eAnnotationHandleTypes.DeleteButton))) {
					continue;
				}
				var bHitDetected = this.isclickWithinAnnotationHandle(oClickCoords, g_oAnnotationActions.g_oArtworkCanvas.g_iRotDegrees, parseInt(iHandleType));
				if (bHitDetected) {
					return parseInt(iHandleType);
				}
			}
		}

		return -1;
	};

	// Check if the user click coordinates are within the handles coordinates on the annotation.
	AnnotationAction.prototype.isclickWithinAnnotationHandle = function (oClickCoords, iRotDegrees, iHandleType) {
		var oAnnotationContext = g_oAnnotationActions.g_oAnnotationCanvas.g_oContext;

		var oHandleCoords = this.calculateAnnotationHandleCoords(iRotDegrees, iHandleType);
		this.drawAnnotationHandle(oHandleCoords, "rgba(0,0,0,0)", false, iHandleType);
		return oAnnotationContext.isPointInPath(oClickCoords[0], oClickCoords[1]);
	};

	/**
	 * To be used when working with a handler that isn't attached to a shape, like when a shape isn't saved yet for example.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 * @param {enum} iHandleType - The handle that was clicked.
	 * @param {double} coords - The coordinates of the marquee.
	 * @param {object} payload - The information about the annotation.
	 */
	AnnotationAction.prototype.handleHandler = function (oArtworkCanvas, oAnnotationCanvas, iHandleType, coords, payload) {

		// Determine the handle type.
		switch (iHandleType) {
			case eAnnotationHandleTypes.CreateNewAnnotation:
				// Clear all bindings.
				changeCanvasFunction("#AnnotationViewer");
				g_oAnnotations.g_szPrevCursorStyle = "default";

				var tmp = coords;
				var szTextContent = [];

				// Set up the new annotation.
				var g_oNewAnnotation = new window.Annotation(g_oAnnotations.g_iApprovalId);
				g_oNewAnnotation.id = g_oAnnotations.getNextAnnotationId();
				g_oNewAnnotation.g_iAuthor = g_oUserDetails.UserId;
				g_oNewAnnotation.g_szAuthorEmail = g_oUserDetails.EmailAddress;
				g_oNewAnnotation.g_szColour = g_oAnnotations.g_oAnnotationColSelected;
				g_oNewAnnotation.g_oDrawArray = deepCopyArray(tmp);		// Deep copy of the array.
				g_oAnnotations.g_oTempAnnotationArray.length = 0;		// Clear out the temp array now that we've copied the contents.

				g_oNewAnnotation.status = "a";
				g_oNewAnnotation.g_iDocumentId = oArtworkCanvas.g_oDoc.documentId;

				// Populate new annotation text box with the payload contents & set annotation type
				switch (payload.type) {
					case eAnnotationTypes.PointToPointMeasurement:
						g_oNewAnnotation.g_iAnnotationType = eAnnotationTypes.Line;
						szTextContent.push(g_oAnnotations.c_szMeasurementHeight, ": ", payload.height, "<br />", g_oAnnotations.c_szMeasurementWidth, ": ", payload.width, "<br />",
							g_oAnnotations.c_szMeasurementLength, ": ", payload.lineLength, "<br />", g_oAnnotations.c_szMeasurementDegrees, ": ", payload.degrees, "<br />");
						g_oNewAnnotation.g_szTextContent = szTextContent.join("");
						break;
					case eAnnotationTypes.AreaMeasurement:
						g_oNewAnnotation.g_iAnnotationType = eAnnotationTypes.Rectangle;
						szTextContent.push(g_oAnnotations.c_szMeasurementHeight, ": ", payload.height, "<br />", g_oAnnotations.c_szMeasurementWidth, ": ", payload.width, "<br />",
							g_oAnnotations.c_szMeasurementArea, ": ", payload.area, "<br />");
						g_oNewAnnotation.g_szTextContent = szTextContent.join("");
						break;
					case eAnnotationTypes.ColourDensityMeasurement:
						// Set the type to post-it if the mouse didn't move.
						g_oNewAnnotation.g_iAnnotationType = (coords[0][0] === coords[1][0] || coords[0][1] === coords[1][1]) ? eAnnotationTypes.ColourDensityMeasurementPostit : eAnnotationTypes.ColourDensityMeasurement;
						for (var i = 0; i < g_oViewer.g_oArtworkViewer.g_oaImages.length; i++) {
							szTextContent.push(g_oViewer.g_oArtworkViewer.g_oaImages[i].SeparationName, ": ", (Math.round((1 - ((parseInt(payload.separations[g_oViewer.g_oArtworkViewer.g_oaImages[i].SeparationName][0])) / 255)) * 10000) / 100).toFixed(0), "%", "<br />");
						}

						g_oNewAnnotation.g_szTextContent = szTextContent.join("");
						break;
					case eAnnotationTypes.BarcodeMeasurement:
						g_oNewAnnotation.g_iAnnotationType = eAnnotationTypes.BarcodeMeasurement;
						g_oNewAnnotation.g_szTextContent = payload.barcodeMeasurements[0].DisplayText;
						g_oNewAnnotation.g_oDrawArray = [[payload.barcodeMeasurements[0].X, payload.barcodeMeasurements[0].Y], [payload.barcodeMeasurements[0].X + payload.barcodeMeasurements[0].Width, payload.barcodeMeasurements[0].Y + payload.barcodeMeasurements[0].Height]];
						break;
					case eAnnotationTypes.TextMeasurement:
					case eAnnotationTypes.TextHighlight:
					case eAnnotationTypes.TextClassification:
					case eAnnotationTypes.HorizontalCalliperMeasurement:
					case eAnnotationTypes.VerticalCalliperMeasurement:
					default:
						g_oNewAnnotation.g_iAnnotationType = eAnnotationTypes.Rectangle;
						break;
				}

				// If we have more than one page, grab the page id by looping through the pages.
				if (!$.isEmptyObject(oArtworkCanvas.g_oDoc.pages)) {
					for (var i = 0; i < oArtworkCanvas.g_oDoc.pages.length; i++) {
						if (oArtworkCanvas.g_oDoc.pages[i].documentPageNumber == oArtworkCanvas.g_iCurrentPage) {
							g_oNewAnnotation.g_iDocumentPageId = oArtworkCanvas.g_oDoc.pages[i].documentPageId;
							break;
						}
					}
				}

				g_oNewAnnotation.g_iParentAnnotationId = 0;

				// Find max annotation number and add 1. We have our new annotation number
				// If there are no annotations we must do a max of the result or 1. Otherwise -infinity is returned
				// Which actually evaluates to isNaN = false!
				g_oNewAnnotation.g_iNumber = Math.max(1, Math.max.apply(Math, g_oAnnotations.g_oAnnotationsMade.map(function (o) { return o.g_iNumber; })) + 1);

				// Push the new annotation into the Annotations made Array
				g_oAnnotations.g_oAnnotationsMade.push(g_oNewAnnotation);
				g_oNewAnnotation.createAnnotationDiv(eAnnotationDivType.Popup, true, null, oArtworkCanvas, oAnnotationCanvas);

				if (g_oNewAnnotation) {
					g_oNewAnnotation.createdDate = moment.utc(new Date(), moment.ISO_8601).local();
				}

				//$("#divTechToolsClearCanvas").click();
				g_oAnnotations.redrawAnnotations(oArtworkCanvas, oAnnotationCanvas);

				//changeCanvasFunction();
				oAnnotationCanvas.dragDiscontinue(false, []);
				$(".jqte_editor").focus();
				break;
			case eAnnotationHandleTypes.DragRect:
			case eAnnotationHandleTypes.LeftResize:
			case eAnnotationHandleTypes.RightResize:
			case eAnnotationHandleTypes.TopResize:
			case eAnnotationHandleTypes.BottomResize:
			case eAnnotationHandleTypes.DeleteButton:
				break;
			default:
				return;
		}
	};

	/**
	 * Handles any functionality determined with clicking on the handles.
	 * @param {event} event - The event
	 * @param {object} oArtworkCanvas - The artwork canvas
	 * @param {object} oAnnotationCanvas - The annotation canvas
	 * @param {object} oAnnotation - The annotation in question
	 * @param {enum} iHandleType - The type of handle
	 */
	AnnotationAction.prototype.shapeHandler = function (event, oArtworkCanvas, oAnnotationCanvas, oAnnotation, iHandleType) {
		var compareOffset_x, compareOffset_y;
		var co = g_oCompare.calculateCompareOffsetInPx(oArtworkCanvas);
		compareOffset_x = co.x;
		compareOffset_y = co.y;

		var relatedArtworkCanvas = oArtworkCanvas;

		var coords = g_oAnnotations.getClick(event, relatedArtworkCanvas);
		if (typeof CanvasRenderingContext2D.prototype.isPointInStroke === "undefined") {
			coords = g_oAnnotations.transformClickForRotation(coords[0], coords[1], relatedArtworkCanvas);
			coords[0] += relatedArtworkCanvas.g_iCenterShift_x + compareOffset_x;
			coords[1] += relatedArtworkCanvas.g_iCenterShift_y + compareOffset_y;
		}

		var oAnnotationStack = g_oAnnotations.getAnnotationStackCurrentPage(oArtworkCanvas);
		if (!g_oAnnotations.isAnnotationClosed(oAnnotation, oAnnotationStack)) {
			// Setup events for annotation actions.
			if (iHandleType > -1) {
				switch (iHandleType) {
					case eAnnotationHandleTypes.DragRect:
						var canvasCoords = findClickCanvasCoordinates(event, oArtworkCanvas, g_oAnnotations);

						g_oAnnotations.g_iOrigClickX = canvasCoords[0];
						g_oAnnotations.g_iOrigClickY = canvasCoords[1];

						changeCanvasFunction("#AnnotationViewer"); // Clear all bindings
						$('#AnnotationViewer').on("pointerup.annotationUI", function (e) {
							g_oAnnotationActions.dragMouseUp(oAnnotation, oArtworkCanvas, oAnnotationCanvas);
						});
						$('#AnnotationViewer').on("pointermove.annotationUI", function (e) {
							g_oAnnotationActions.dragMouseMove(oAnnotation, e, oArtworkCanvas, g_oAnnotations.g_iOrigClickX, g_oAnnotations.g_iOrigClickY);
						});
						return;
					case eAnnotationHandleTypes.BottomResize:
					case eAnnotationHandleTypes.TopResize:
					case eAnnotationHandleTypes.LeftResize:
					case eAnnotationHandleTypes.RightResize:
						var canvasCoords = findClickCanvasCoordinates(event, oArtworkCanvas, g_oAnnotations);

						g_oAnnotations.g_iOrigClickX = canvasCoords[0];
						g_oAnnotations.g_iOrigClickY = canvasCoords[1];

						changeCanvasFunction("#AnnotationViewer"); // Clear all bindings
						$('#AnnotationViewer').on("pointerup.annotationUI", function (e) {
							g_oAnnotationActions.dragMouseUp(oAnnotation, oArtworkCanvas, oAnnotationCanvas);
						});
						$('#AnnotationViewer').on("pointermove.annotationUI", function (e) {
							g_oAnnotationActions.resizeDragMove(oAnnotation, e, oArtworkCanvas, oAnnotationCanvas, g_oAnnotations.g_iOrigClickX, g_oAnnotations.g_iOrigClickY, iHandleType);
						});
						return;
					case eAnnotationHandleTypes.DeleteButton:
						g_oAnnotations.deleteAnnotation(oAnnotation.id, oAnnotationStack, false, oArtworkCanvas, oAnnotationCanvas);
						g_oAnnotations.redrawAnnotations(oArtworkCanvas, oAnnotationCanvas);
						$("#divTechToolsClearCanvas").click();
						$("#AnnotationViewer").css("cursor", "default");
						g_oAnnotations.g_szPrevCursorStyle = "default";
						changeCanvasFunction('#AnnotationViewer', "pointermove.annotationUI", function (e) { g_oAnnotationActions.mouseMove(e, oArtworkCanvas, oAnnotationCanvas); });
						break;
					default:
						break;
				}
			}
		}
	};

	/**
	 * Mouse/Pointer release event when dragging the annotations with their handles.
	 * @param {object} oAnnotation - The annotation being dragged.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	AnnotationAction.prototype.dragMouseUp = function (oAnnotation, oArtworkCanvas, oAnnotationCanvas) {
		$('#AnnotationViewer').css("cursor", "default");
		changeCanvasFunction();
		oAnnotation.annotationSaveShape(oAnnotationCanvas, true);
		g_oAnnotations.redrawAnnotations(oArtworkCanvas, oAnnotationCanvas);
	};

	/**
	 * Handles the moving of annotations via the move handle.
	 * @param {object} oAnnotation - The annotation being dragged.
	 * @param {event} e - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {double} iOrigX - The Old X coordinate.
	 * @param {double} iOrigY - THe Old Y coordinate.
	 */
	AnnotationAction.prototype.dragMouseMove = function (oAnnotation, e, oArtworkCanvas, iOrigX, iOrigY) {
		$('.speechbubble').hide();
		var oAnnotationCanvasObject = this.g_oAnnotationCanvas.g_oCanvas;
		var coords = findClickCanvasCoordinates(e, oArtworkCanvas, g_oAnnotations);

		var iNewX = coords[0];
		var iNewY = coords[1];

		g_oAnnotations.g_iOrigClickX = iNewX;
		g_oAnnotations.g_iOrigClickY = iNewY;

		var iOffXt = iNewX - iOrigX;
		var iOffYt = iNewY - iOrigY;
		var iOffX;
		var iOffY;
		switch (oArtworkCanvas.g_iRotDegrees) {
			case 90:
				iOffX = iOffYt;
				iOffY = iOffXt * -1;
				break;
			case 180:
				iOffX = iOffXt * -1;
				iOffY = iOffYt * -1;
				break;
			case 270:
				iOffX = iOffYt * -1;
				iOffY = iOffXt;
				break;
			default:
				iOffX = iOffXt;
				iOffY = iOffYt;
				break;
		}
		// Create a copy of the array
		var arrayCopy = deepCopyArray(oAnnotation.g_oDrawArray);
		var bCanMoveX = true;
		var bCanMoveY = true;
		// Check whether dragging any further would put the shape out of bounds
		for (var i = 0; i < arrayCopy.length; i++) {
			if (arrayCopy[i][0] + iOffX > 1 || arrayCopy[i][0] + iOffX < 0) {
				bCanMoveX = false;
			}
			if (arrayCopy[i][1] + iOffY > 1 || arrayCopy[i][1] + iOffY < 0) {
				bCanMoveY = false;
			}
		}
		if (bCanMoveX) { // Apply the x coordinate changes.
			for (var i = 0; i < oAnnotation.g_oDrawArray.length; i++) {
				oAnnotation.g_oDrawArray[i][0] += iOffX;
				oAnnotation.g_oDrawCoordSetArray[i].xCoordinate += iOffX;
			}
		}
		if (bCanMoveY) { // Apply the y coordinate changes
			for (var i = 0; i < oAnnotation.g_oDrawArray.length; i++) {
				oAnnotation.g_oDrawArray[i][1] += iOffY;
				oAnnotation.g_oDrawCoordSetArray[i].yCoordinate += iOffY;
			}
		}
		this.g_oAnnotationCanvas.g_oContext.clearRect(0, 0, oAnnotationCanvasObject.width, oAnnotationCanvasObject.height);
		g_oAnnotations.redrawAnnotations(oArtworkCanvas, this.g_oAnnotationCanvas, oAnnotation.id);
	};

	/**
	 * Handles resizing of annotations via drag handles
	 * @param {object} oAnnotation - The annotation being resized.
	 * @param {event} e - The event
	 * @param {object} oArtworkCanvas - The artwork canvas
	 * @param {object} g_oAnnotationCanvas - The annotation canvas
	 * @param {double} iOrigX - The Old X coordinate.
	 * @param {double} iOrigY - The Old Y coordinate.
	 * @param {enum} iHandleType - The handle the annotation is being dragged by.
	 */
	AnnotationAction.prototype.resizeDragMove = function (oAnnotation, e, oArtworkCanvas, g_oAnnotationCanvas, iOrigX, iOrigY, iHandleType) {
		$('.speechbubble').hide();

		var minXindex, minYindex, maxXindex, maxYindex;
		// Work out the min/max X/Y coordinate holders
		if (oAnnotation.g_iAnnotationType != eAnnotationTypes.Freedraw) {
			minXindex = (oAnnotation.g_oDrawArray[0][0] < oAnnotation.g_oDrawArray[1][0]) ? 0 : 1;
			minYindex = (oAnnotation.g_oDrawArray[0][1] < oAnnotation.g_oDrawArray[1][1]) ? 0 : 1;
			maxXindex = (minXindex === 0) ? 1 : 0;
			maxYindex = (minYindex === 0) ? 1 : 0;
		}
		else {
			minXindex = 0;
			minYindex = 0;
			maxXindex = 0;
			maxYindex = 0;
			for (var i = 0; i < oAnnotation.g_oDrawArray.length; i++) {
				minXindex = (oAnnotation.g_oDrawArray[i][0] <= oAnnotation.g_oDrawArray[minXindex][0]) ? i : minXindex;
				maxXindex = (oAnnotation.g_oDrawArray[i][0] >= oAnnotation.g_oDrawArray[maxXindex][0]) ? i : maxXindex;
				minYindex = (oAnnotation.g_oDrawArray[i][1] <= oAnnotation.g_oDrawArray[minYindex][1]) ? i : minYindex;
				maxYindex = (oAnnotation.g_oDrawArray[i][1] >= oAnnotation.g_oDrawArray[maxYindex][1]) ? i : maxYindex;
			}
		}

		var oAnnotationCanvasObject = this.g_oAnnotationCanvas.g_oCanvas;
		var coords = findClickCanvasCoordinates(e, oArtworkCanvas, g_oAnnotations);

		var iNewX = coords[0];
		var iNewY = coords[1];

		g_oAnnotations.g_iOrigClickX = iNewX;
		g_oAnnotations.g_iOrigClickY = iNewY;

		// Transform the offset based on canvas rotation
		var iOffXt = iNewX - iOrigX;
		var iOffYt = iNewY - iOrigY;
		var iOffX;
		var iOffY;
		switch (oArtworkCanvas.g_iRotDegrees) {
			case 90:
				iOffX = iOffYt;
				iOffY = iOffXt * -1;
				break;
			case 180:
				iOffX = iOffXt * -1;
				iOffY = iOffYt * -1;
				break;
			case 270:
				iOffX = iOffYt * -1;
				iOffY = iOffXt;
				break;
			default:
				iOffX = iOffXt;
				iOffY = iOffYt;
				break;
		}

		if (oAnnotation.g_iAnnotationType != eAnnotationTypes.Freedraw) {
			switch (iHandleType) {
				case eAnnotationHandleTypes.LeftResize:
					// Only update the X coordinate of the leftmost point. Only update if it's still within bounds after.
					if (oAnnotation.g_oDrawArray[minXindex][0] + iOffX <= 1 && oAnnotation.g_oDrawArray[minXindex][0] + iOffX >= 0) {
						oAnnotation.g_oDrawArray[minXindex][0] += iOffX;
						oAnnotation.g_oDrawCoordSetArray[minXindex].xCoordinate += iOffX;
					}
					break;
				case eAnnotationHandleTypes.RightResize:
					// Only update the X coordinate of the rightmost point. Only update if it's still within bounds after.
					if (oAnnotation.g_oDrawArray[maxXindex][0] + iOffX <= 1 && oAnnotation.g_oDrawArray[maxXindex][0] + iOffX >= 0) {
						oAnnotation.g_oDrawArray[maxXindex][0] += iOffX;
						oAnnotation.g_oDrawCoordSetArray[maxXindex].xCoordinate += iOffX;
					}
					break;
				case eAnnotationHandleTypes.TopResize:
					// Only update the Y coordinate of the highest point. Only update if it's still within bounds after.
					if (oAnnotation.g_oDrawArray[minYindex][1] + iOffY <= 1 && oAnnotation.g_oDrawArray[minYindex][1] + iOffY >= 0) {
						oAnnotation.g_oDrawArray[minYindex][1] += iOffY;
						oAnnotation.g_oDrawCoordSetArray[minYindex].yCoordinate += iOffY;
					}
					break;
				case eAnnotationHandleTypes.BottomResize:
					// Only update the Y coordinate of the lowest point. Only update if it's still within bounds after.
					if (oAnnotation.g_oDrawArray[maxYindex][1] + iOffY <= 1 && oAnnotation.g_oDrawArray[maxYindex][1] + iOffY >= 0) {
						oAnnotation.g_oDrawArray[maxYindex][1] += iOffY;
						oAnnotation.g_oDrawCoordSetArray[maxYindex].yCoordinate += iOffY;
					}
					break;
				default:
					break;
			}
		}
		else {
			var tCoords = g_oAnnotations.getClick(e, g_oAnnotationCanvas);
			if (g_oAnnotationCanvas.isClickWithinImageBounds(tCoords[0], tCoords[1], oArtworkCanvas, g_oAnnotationCanvas)) {
				switch (iHandleType) {
					case eAnnotationHandleTypes.LeftResize:
						this.applyFreedrawCoordChange(oAnnotation, true, false, -iOffX);
						break;
					case eAnnotationHandleTypes.RightResize:
						this.applyFreedrawCoordChange(oAnnotation, true, true, iOffX);
						break;
					case eAnnotationHandleTypes.TopResize:
						this.applyFreedrawCoordChange(oAnnotation, false, false, -iOffY);
						break;
					case eAnnotationHandleTypes.BottomResize:
						this.applyFreedrawCoordChange(oAnnotation, false, true, iOffY);
						break;
					default:
						break;
				}
			}
		}
		this.g_oAnnotationCanvas.g_oContext.clearRect(0, 0, oAnnotationCanvasObject.width, oAnnotationCanvasObject.height);
		g_oAnnotations.redrawAnnotations(oArtworkCanvas, this.g_oAnnotationCanvas, oAnnotation.id);
	};

	/**
	 * Applies the coordinate changes if the freedraw shape were to stay in bounds.
	 * @param {object} oAnnotation - The annotation
	 * @param {boolean} bHorizontal - Whether a horizontal handle was selected
	 * @param {boolean} bEndMost - Whether it's the end (right or bottom) handle.
	 * @param {int} iOffset - How much to move it by.
	 */
	AnnotationAction.prototype.applyFreedrawCoordChange = function (oAnnotation, bHorizontal, bEndMost, iOffset) {
		// Set up the variables.
		var arrayCopy = deepCopyArray(oAnnotation.g_oDrawArray);
		var iCoordinate = bHorizontal ? 0 : 1; // Changes to the X or Y coordinate.
		// Get the relevant size. Height for vertical changes, Width for horizontal changes.
		var iSize = bHorizontal ? arrayCopy.concat().sort(sortAnnotationCoords.returnXMax)[0][iCoordinate] - arrayCopy.concat().sort(sortAnnotationCoords.returnXMin)[0][iCoordinate]
			: arrayCopy.concat().sort(sortAnnotationCoords.returnYMax)[0][iCoordinate] - arrayCopy.concat().sort(sortAnnotationCoords.returnYMin)[0][iCoordinate];
		var iDistance;
		if (bHorizontal) {
			iDistance = bEndMost ? arrayCopy.concat().sort(sortAnnotationCoords.returnXMin)[0][iCoordinate] : arrayCopy.concat().sort(sortAnnotationCoords.returnXMax)[0][iCoordinate];
		}
		else {
			iDistance = bEndMost ? arrayCopy.concat().sort(sortAnnotationCoords.returnYMin)[0][iCoordinate] : arrayCopy.concat().sort(sortAnnotationCoords.returnYMax)[0][iCoordinate];
		}

		var bClear = true;
		for (var i = 0; i < oAnnotation.g_oDrawArray.length; i++) {
			var diff = arrayCopy[i][iCoordinate] - iDistance;
			var iMult = diff / iSize;
			// Check whether any of the coordinates would move out of bounds.
			if (bClear && (arrayCopy[i][iCoordinate] + (iOffset * iMult) >= 1 || arrayCopy[i][iCoordinate] + (iOffset * iMult) < 0)) {
				bClear = false;
			}
			// Apply changes if safe.
			if (bClear) {
				oAnnotation.g_oDrawArray[i][iCoordinate] += (iOffset * iMult);
				if (bHorizontal) {
					oAnnotation.g_oDrawCoordSetArray[i].xCoordinate += (iOffset * iMult);
				}
				else {
					oAnnotation.g_oDrawCoordSetArray[i].yCoordinate += (iOffset * iMult);
				}

			}
		}
	};

	/**
	 * Light version of the mouseMove method that only checks for annotation shapes themselves, ignores handles.
	 * @param {event} e - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	AnnotationAction.prototype.mouseMoveLite = function (e, oArtworkCanvas, oAnnotationCanvas) {
		g_oAnnotations.findAnnotation(e, oArtworkCanvas, oAnnotationCanvas, true);
		$("#" + e.target.id).css("cursor", (g_oAnnotations.g_bAnnotationsFound) ? "pointer" : g_oAnnotations.g_szPrevCursorStyle);
	};

	/**
	 * Checks whether a handle was clicked and calls the handler.
	 * @param {event} e - the event
	 * @param {object} oArtworkCanvas - the artwork canvas
	 * @param {object} oAnnotationCanvas - the annotation canvas
	 */
	AnnotationAction.prototype.handleClick = function (e, oArtworkCanvas, oAnnotationCanvas) {
		
		// If we are text compare mode and not in a text highlight, allow text compare to handle the click.
		if (g_oTextCompare.g_bTextCompareInProgress && !g_oTextTools.g_bHighlightInProgress) {
			return;
		}

		var coords = g_oAnnotations.getClick(e, oArtworkCanvas);
		var oAnnotationStack = g_oAnnotations.getAnnotationStackCurrentPage(oArtworkCanvas);
		for (var i = 0; i < oAnnotationStack.length; i++) {
			var iHandleType = g_oAnnotationActions.isclickWithinAnnotationAnyHandle(coords, oAnnotationStack[i]);
			if (iHandleType > -1) {
				this.shapeHandler(e, oArtworkCanvas, oAnnotationCanvas, oAnnotationStack[i], iHandleType);
			}
		}
	};

	/**
	 * Changes cursor based on whether a handle (for a non-existent annotation) was hovered over.
	 * @param {event} e - the event.
	 * @param {object} oArtworkCanvas - the artwork canvas.
	 * @param {object} oAnnotationCanvas - the annotation canvas.
	 * @param {array} handleData - coordinates of the handle.
	 * @param {enum} handleType - what type of handle it is.
	 */
	AnnotationAction.prototype.mouseMoveAnnotationHandles = function (e, oArtworkCanvas, oAnnotationCanvas, handleData, handleType) {
		
		// Get the mouse coordinates.
		var mouseCoordinates = g_oAnnotations.getClick(e, oArtworkCanvas);

		// Keep track of if we are over a handle.
		var bMouseOverHandle = false;

		// Loop through each of the handle coordinates.
		for (var i = 0; i < handleData.length; i++) {

			// Check if we are over the handle.
			if ((Math.abs(mouseCoordinates[0] - handleData[i].handleX - this.calculateAnnotationHandleSize(handleType)[0] / 2) < this.calculateAnnotationHandleSize(handleType)[0] / 2)
				&& (Math.abs(mouseCoordinates[1] - handleData[i].handleY - this.calculateAnnotationHandleSize(handleType)[1] / 2) < this.calculateAnnotationHandleSize(handleType)[1] / 2)) {

				// Set that we are over the handle.
				bMouseOverHandle = true;
				break;
			}
		}

		// Set the cursor.
		$('#AnnotationViewer').css("cursor", (bMouseOverHandle ? "pointer" : g_oAnnotations.g_szPrevCursorStyle));
	};

	/**
	 * Checks whether a handle was clicked for a non-existent annotation and calls the handler.
	 * @param {event} e - the event
	 * @param {object} oArtworkCanvas - the artwork canvas.
	 * @param {object} oAnnotationCanvas - the annotation canvas.
	 * @param {array} handleData - Handle location and where to draw the annotation.
	 * @param {enum} handleType - What type of handle was clicked.
	 */
	AnnotationAction.prototype.mouseClickAnnotationHandles = function (e, oArtworkCanvas, oAnnotationCanvas, handleData, handleType) {

		// Get the mouse coordinates.
		var mouseCoordinates = g_oAnnotations.getClick(e, oArtworkCanvas);

		// Loop through each of the handle coordinates.
		for (var i = 0; i < handleData.length; i++) {

			// Check if we are over the handle.
			if ((Math.abs(mouseCoordinates[0] - handleData[i].handleX - this.calculateAnnotationHandleSize(handleType)[0] / 2) < this.calculateAnnotationHandleSize(handleType)[0] / 2)
				&& (Math.abs(mouseCoordinates[1] - handleData[i].handleY - this.calculateAnnotationHandleSize(handleType)[1] / 2) < this.calculateAnnotationHandleSize(handleType)[1] / 2)) {

				// Action the handle.
				this.handleHandler(oArtworkCanvas, oAnnotationCanvas, handleType, handleData[i].annotationCoordinates, handleData[i].annotationData);
				return;
			}
		}

		// We are not over a handle, remove the pointer down event.
		$("#AnnotationViewer").off("pointerdown.annotationUI");
	};

	/**
	 * Changes the mouse cursor based on what handle/annotation was hovered over.
	 * @param {event} e - The event.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 */
	AnnotationAction.prototype.mouseMove = function (e, oArtworkCanvas, oAnnotationCanvas) {
		var coords = g_oAnnotations.getClick(e, oArtworkCanvas);

		var oAnnotationStack = g_oAnnotations.getAnnotationStackCurrentPage(oArtworkCanvas);
		for (var i = 0; i < oAnnotationStack.length; i++) {
			var iHandleType = g_oAnnotationActions.isclickWithinAnnotationAnyHandle(coords, oAnnotationStack[i]);
			switch (iHandleType) {
				case eAnnotationHandleTypes.DragRect:
					$('#AnnotationViewer').css('cursor', 'move');
					return;
				case eAnnotationHandleTypes.DeleteButton:
					$('#AnnotationViewer').css('cursor', 'pointer');
					return;
				case eAnnotationHandleTypes.TopResize:
				case eAnnotationHandleTypes.BottomResize:
					$('#AnnotationViewer').css('cursor', (oArtworkCanvas.g_iRotDegrees === 90 || oArtworkCanvas.g_iRotDegrees === 270) ? 'ew-resize' : 'ns-resize');
					return;
				case eAnnotationHandleTypes.LeftResize:
				case eAnnotationHandleTypes.RightResize:
					$('#AnnotationViewer').css('cursor', (oArtworkCanvas.g_iRotDegrees === 90 || oArtworkCanvas.g_iRotDegrees === 270) ? 'ns-resize' : 'ew-resize');
					return;
				default:
					break;
			}
		}
		g_oAnnotations.findAnnotation(e, oArtworkCanvas, oAnnotationCanvas, true);
		$('#AnnotationViewer').css("cursor", (g_oAnnotations.g_bAnnotationsFound) ? "pointer" : g_oAnnotations.g_szPrevCursorStyle);
	};

	window.AnnotationAction = AnnotationAction;
}());